/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";

import {payloadGenerator} from "@/helpers/payloadGenerator";

export default {
	fetchBatteryAlarms({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/alarm/battery")
				.then((response) => {
					commit("SET_ALARM", response.data);
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchGpsAlarms({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/alarm/gps")
				.then((response) => {
					commit("SET_ALARM", response.data);
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchRadioAlarms({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/alarm/schedule/zone")
				.then((response) => {
					commit("SET_ALARM", response.data);
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchScheduleAlarms({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/alarm/schedule")
				.then((response) => {
					commit("SET_ALARM", response.data);
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchZoneAlarms({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/alarm/zone")
				.then((response) => {
					commit("SET_ALARM", response.data);
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	updateBatteryAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.put(`/alarm/battery/${alarm.key}`, alarm)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	createBatteryAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.post("/alarm/battery", alarm)
				.then((response) => {
					alarm.key = response.data.key;
					resolve(alarm);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	createGpsAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.post("/alarm/gps", alarm)
				.then((response) => {
					alarm.key = response.data.key;
					resolve(alarm);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateGpsAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.put(`/alarm/gps/${alarm.key}`, alarm)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	createRadioAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.post("/alarm/schedule/zone", alarm)
				.then((response) => {
					alarm.key = response.data.key;
					resolve(alarm);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateRadioAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.put(`/alarm/schedule/zone/${alarm.key}`, alarm)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// scheduler
	createScheduleAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.post("/alarm/schedule", alarm)
				.then((response) => {
					alarm.key = response.data.key;
					resolve(alarm);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateScheduleAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.put(`/alarm/schedule/${alarm.key}`, alarm)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeBatteryAlarm({commit}, alarmKey) {
		return new Promise((resolve, reject) => {
			Api.delete(`/alarm/battery/${alarmKey}`)
				.then((response) => {
					commit("REMOVE_ALARM", alarmKey);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeGpsAlarm({commit}, alarmKey) {
		return new Promise((resolve, reject) => {
			Api.delete(`/alarm/gps/${alarmKey}`)
				.then((response) => {
					commit("REMOVE_ALARM", alarmKey);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeRadioAlarm({commit}, alarmKey) {
		return new Promise((resolve, reject) => {
			Api.delete(`/alarm/schedule/zone/${alarmKey}`)
				.then((response) => {
					commit("REMOVE_ALARM", alarmKey);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeScheduleAlarm({commit}, alarmKey) {
		return new Promise((resolve, reject) => {
			Api.delete(`/alarm/schedule/${alarmKey}`)
				.then((response) => {
					commit("REMOVE_ALARM", alarmKey);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeZoneAlarm({commit}, alarmKey) {
		return new Promise((resolve, reject) => {
			Api.delete(`/alarm/zone/${alarmKey}`)
				.then((response) => {
					commit("REMOVE_ALARM", alarmKey);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeScheduleAlarms({commit}, alarmKey) {
		return new Promise((resolve, reject) => {
			Api.delete(`/alarm/schedule/${alarmKey}`)
				.then((response) => {
					commit("REMOVE_ALARM", alarmKey);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// zone
	createZoneAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.post("/alarm/zone", alarm)
				.then((response) => {
					alarm.key = response.data.key;
					resolve(alarm);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateZoneAlarm({commit}, alarm) {
		return new Promise((resolve, reject) => {
			Api.put(`/alarm/zone/${alarm.key}`, alarm)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	addGroupActivity({commit}, groupItem) {
		commit("ADD_GROUP_ACTIVITY", groupItem);
	},
	removeGroupActivity({commit}, groupItem) {
		commit("REMOVE_GROUP_ACTIVITY", groupItem);
	},
	cleanGroupActivity({commit}, groupItem) {
		commit("CLEAN_GROUP_ACTIVITY");
	},
	getGroupsByFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000,
				fields: data.fields || [],
				id: data.ids || [],
				name: data.name || "",
				description: data.description || "",
				city: data.city || "",
				country: data.country || "",
				address: data.address || "",
				dirtrad: data.dirtrad || "",
				hour_init: data.hour_init || "",
				hour_end: data.hour_end || "",
				order_by: data.order_by || "name",
			};
			Api.post("/group/filter", payload)
				.then((res) => {
					commit("SET_GROUPS_ACTIVITY", res.data.records);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},

	// actions for SpeedAlarm
	async fetchSpeedAlarms({commit}) {
		try {
			const response = await Api.get("/alarm/speed");
			commit("SET_ALARM", response.data);
			return response;
		} catch (error) {
			throw error;
		}
	},

	async createSpeedAlarm({commit}, alarm) {
		const payload = payloadGenerator(alarm, "AlarmSpeed", "create");
		try {
			const response = await Api.post("/alarm/speed", payload);
			return response.data;
		} catch (error) {
			throw error;
		}
	},
	async updateSpeedAlarm({commit}, alarm) {
		const payload = payloadGenerator(alarm, "AlarmSpeed", "update");
		try {
			const response = await Api.put(`/alarm/speed/${alarm.id}`, payload);
			return response.data;
		} catch (error) {
			throw error;
		}
	},
	async removeSpeedAlarm({commit}, id) {
		try {
			const response = await Api.delete(`/alarm/speed/${id}`);
			commit("REMOVE_ALARM_BY_ID", id);
			return response;
		} catch (error) {
			throw error;
		}
	},
};
